import { create } from 'zustand';
import type { User } from '@/types/auth';
import { getMe, login as apiLogin } from '@/api/auth';

interface AuthState {
  token: string | null;
  user: User | null;
  loading: boolean;
  error: string | null;
}

interface AuthActions {
  init: () => Promise<void>;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
  setError: (error: string | null) => void;
}

const storedToken = localStorage.getItem('deepflow_token');

export const useAuthStore = create<AuthState & AuthActions>((set, get) => ({
  token: storedToken,
  user: null,
  loading: false,
  error: null,

  init: async () => {
    if (!get().token) return;
    set({ loading: true, error: null });
    try {
      const user = await getMe();
      set({ user, loading: false });
    } catch {
      localStorage.removeItem('deepflow_token');
      set({ token: null, user: null, loading: false });
    }
  },

  login: async (username: string, password: string) => {
    set({ loading: true, error: null });
    try {
      const data = await apiLogin(username, password);
      localStorage.setItem('deepflow_token', data.access_token);
      set({ token: data.access_token, user: data.user, loading: false });
      return true;
    } catch (err) {
      const message = err instanceof Error ? err.message : '登录失败';
      set({ error: message, loading: false });
      return false;
    }
  },

  logout: () => {
    localStorage.removeItem('deepflow_token');
    set({ token: null, user: null, error: null });
  },

  setError: (error: string | null) => set({ error }),
}));
